import { type CategoryTreeSubjectNameData } from '@/api';
import { useLocale } from '@/hooks';
import { getSubjectLocaleName } from '@/shared/category/getSubjectLocaleName';
import { Chip } from '@/shared/components/Chip/QuizInfoChip';
export const SubjectChip = (props: CategoryTreeSubjectNameData & {
  className?: string;
}) => {
  const {
    className
  } = props;
  const {
    locale
  } = useLocale();
  const subjectName = getSubjectLocaleName({
    localizeNames: props.subjectLocalizeNames,
    defaultName: props.subjectName,
    locale
  });
  const subSubjectName = props.subSubjectName ? getSubjectLocaleName({
    localizeNames: props.subSubjectLocalizeNames,
    defaultName: props.subSubjectName,
    locale
  }) : undefined;
  return <Chip className={className} data-sentry-element="Chip" data-sentry-component="SubjectChip" data-sentry-source-file="SubjectChip.tsx">
      <span>{subSubjectName ? subSubjectName : subjectName}</span>
    </Chip>;
};